(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["jzlife_vue_servant-app"] = factory();
	else
		root["jzlife_vue_servant-app"] = factory();
})(window, function() {
return 